import httpClient from "@/services/httpClient";
import { server, dispute_resolution_const } from "@/services/constants";

const api_core = `${dispute_resolution_const.dispute_resolution_url}`
//load table genaral
export const dispute_resolution_get_docruningDocket = (company_id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_DOCKET}/docruning-docket/${company_id}`);
};
export const dispute_resolution_get_clienList = (company_id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_DOCKET}/clien-list/${company_id}`);
};
export const dispute_resolution_get_lawyerList = (company_id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_DOCKET}/lawyer-list/${company_id}`);
};
export const dispute_resolution_get_quotationsList = (company_id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_DOCKET}/quotations-list/${company_id}`);
};
export const dispute_resolution_get_invoiceList = (query) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_DOCKET}/invoice-list`, query);
};


//load table dispute_resolution_getall_docket
export const dispute_resolution_get_forDataTable = (company_id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_DOCKET}/get-all-data-table/${company_id}`);
};
export const dispute_resolution_getall_docket = () => {
    return httpClient.get(`${api_core}/${server.LITIGATION_DOCKET}/`);
};
export const dispute_resolution_getbyid_docket = (id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_DOCKET}/by-id/${id}`);
};

export const dispute_resolution_load_file = (id, company_id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_DOCKET}/load-file/${id}/${company_id}`);
};

export const dispute_resolution_update_qutations = (id, data) => {
    return httpClient.put(`${api_core}/${server.LITIGATION_DOCKET}/update-quotations-status/${id}`, data);
};

export const dispute_resolution_upload_file = (data) => {
    return httpClient.post(`${api_core}/${server.LITIGATION_DOCKET}/upload-file`, data);
};
export const dispute_resolution_add_docket = (data) => {
    return httpClient.post(`${api_core}/${server.LITIGATION_DOCKET}/`, data);
};
export const dispute_resolution_update_docket = (id, data) => {
    return httpClient.put(`${api_core}/${server.LITIGATION_DOCKET}/${id}`, data);
};
export const dispute_resolution_delete_docket = (id) => {
    return httpClient.delete(`${api_core}/${server.LITIGATION_DOCKET}/${id}`);
};
export const dispute_resolution_delete_file = (litigation_docket_id, id, file_name) => {
    return httpClient.delete(`${api_core}/${server.LITIGATION_DOCKET}/delete-file/${litigation_docket_id}/${id}/${file_name}`);
};
